enum ProveedorPago{
    
    Kushki = 1,
    Pasarela = 2
}

export default ProveedorPago